module.exports = __webpack_public_path__ + "img/flight-small-bg.ea8203ea.jpg";